import { useAuth } from "./useAuth";

export const useTracker = () => {

    const { user, apiRequestAuthenticated, apiRequest } = useAuth();

    async function trackEvent({ event, value, details }: { event: string, value?: string, details?: any }): Promise<boolean> {

        const body = {
            event,
            value,
            details,
        };

        if (user) {
            await apiRequestAuthenticated({ method: "POST", url: "trackAuth", body });
        } else {
            await apiRequest({ method: "POST", url: "track", body });
        }

        return true;
    }

    return { trackEvent };
}